import { PhoneNumberFormat } from 'google-libphonenumber';

import { CountryCode } from './countries';
import { getPhoneUtil } from './getPhoneUtil';

/**
 * Normalises a complete phone number to E.164 — a single leading `+` followed
 * by digits only — or returns `''` if the input is not a valid number.
 *
 * Passing `countryCode` lets a national number be resolved against that region,
 * which is what drops national trunk prefixes correctly: `07853 775811` with
 * `GB` becomes `+447853775811`, not `+4407853775811`.
 *
 * The empty return is deliberate: callers that hold input which is still being
 * typed need to tell "not a number yet" apart from "here is the number", and a
 * best-effort guess is the wrong thing to persist.
 */
export const toE164 = (
  phoneNumber: string | undefined | null,
  countryCode?: CountryCode
): string => {
  const trimmed = phoneNumber?.trim();

  if (!trimmed) {
    return '';
  }

  const phoneUtil = getPhoneUtil();

  try {
    const parsed = phoneUtil.parse(trimmed, countryCode);

    return phoneUtil.isValidNumber(parsed)
      ? phoneUtil.format(parsed, PhoneNumberFormat.E164)
      : '';
  } catch {
    return '';
  }
};
